import React, { useState } from 'react';
import { X, AlertTriangle } from 'lucide-react';
import Swal from 'sweetalert2';

export default function RejectProposalModal({
  isOpen,
  onClose,
  article,
  onConfirmReject,
}) {
  const [reason, setReason] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (!isOpen || !article) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    const cleanReason = reason.trim();
    if (cleanReason.length < 10) {
      Swal.fire({
        title: 'Motif insuffisant',
        text: 'Le motif de rejet doit comporter au moins 10 caractères explicatifs.',
        icon: 'warning',
      });
      return;
    }

    setIsSubmitting(true);
    try {
      await onConfirmReject(article._id, cleanReason);
      setReason('');
      onClose();
    } catch (err) {
      Swal.fire('Erreur', err.message || 'Impossible de rejeter cet article', 'error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="an-modal-backdrop animate-fade-in" onClick={onClose}>
      <div className="an-modal-card an-modal-small" onClick={(e) => e.stopPropagation()}>
        <div className="an-modal-header border-danger">
          <div className="an-modal-title text-danger">
            <AlertTriangle size={20} className="mr-2" />
            <span>Rejeter la proposition d'article</span>
          </div>
          <button className="an-modal-close" onClick={onClose}>
            <X size={20} />
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="an-modal-body">
            <p className="an-reject-lead">
              Vous êtes sur le point de rejeter l'article suivant :
              <strong className="d-block mt-1">{article.title}</strong>
            </p>

            <div className="an-form-group">
              <label htmlFor="rejectionReason">
                Motif obligatoire du rejet <span className="text-danger">*</span>
                <small className="text-muted d-block">
                  Minimum 10 caractères. Ce motif sera consigné dans le journal d'audit immuable.
                </small>
              </label>
              <textarea
                id="rejectionReason"
                className="an-textarea"
                rows={4}
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                placeholder="Ex: Information non vérifiée, texte réglementaire obsolète, source non officielle..."
                required
              />
              <div className="an-char-counter">
                {reason.trim().length} / 10 caractères minimum
              </div>
            </div>
          </div>

          <div className="an-modal-footer">
            <button
              type="button"
              className="an-btn-secondary"
              onClick={onClose}
              disabled={isSubmitting}
            >
              Annuler
            </button>
            <button
              type="submit"
              className="an-btn-danger"
              disabled={isSubmitting || reason.trim().length < 10}
            >
              {isSubmitting ? 'Rejet en cours...' : 'Confirmer le rejet'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

